<div class="sub-menu-root-container promotion-menu-root-container"
    [style.width]="show ? 'var(--left-side-optionbar-width)' : '25px'">
    <div class="menu-list-container">
        <!-- Masters List -->

        <!-- <mat-list-item *ngIf="userData?.user_type === 'HQ'" class="mat-list-item" routerLink="/reasons"
                    [routerLinkActive]="['is-active']" (click)="resetState()"
                    [matTooltip]="!show ? 'Attendance Data' : ''" matTooltipPosition="right"
                    matTooltipClass="mat-tooltip">
                    <div class="mat-list-item-contents">
                        <img src="assets/images/menu/svg/reasons.svg">
                        <span class="master-title">Reasons
                        </span>
                    </div>
                </mat-list-item> -->
        <mat-list-item class="mat-list-item" *ngIf="userData?.user_type === 'HQ' && hasAccess('vouchers')"
            routerLink="/promotion/voucher" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Vouchers' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/vouchers.svg">
                <span class="master-title" style="word-wrap: break-word;">Voucher
                </span>
            </div>
        </mat-list-item>
        <mat-list-item class="mat-list-item" *ngIf="userData?.user_type === 'HQ' && hasAccess('discount')"
            routerLink="/promotion/discount" [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Employee' : ''"
            matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/discounts.svg">
                <span class="master-title">Discount</span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('auto-discount')" class="mat-list-item"
            routerLink="/promotion/auto-discount" [routerLinkActive]="['is-active']"
            [matTooltip]="!show ? 'Payroll Group' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/auto-discount.svg">
                <span class="master-title"> Auto Discount
                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('item-discount-display-order')"
            class="mat-list-item" routerLink="/promotion/item-discount-display-order" [routerLinkActive]="['is-active']"
            [matTooltip]="!show ? 'Payroll Group' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/display-order.svg">
                <span class="master-title">Display Order
                </span>
            </div>
        </mat-list-item>

    </div>
</div>